import { EmailTypeEnum } from './enum';

export const EMAIL_TITLE = {
    [EmailTypeEnum.ReadyForPickup]: 'Your order is ready for pickup',
    [EmailTypeEnum.OutForDelivery]: 'Your order is out for delivery',
};

export const emailTemplateDefault = (emailType: EmailTypeEnum) => `
    <html>
        <head>
            <title>${EMAIL_TITLE[emailType]}</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <meta name="viewport" content="width=device-width">
            
            <style>
                .templateEmail {
                    max-height: 600px;
                    overflow: auto;
                }

                table {
                    width: 100%;
                    max-width: 560px;
                    margin: 0 auto;
                    border-spacing: 0;
                    border-collapse: collapse;
                }

                .header.row {
                    margin: 40px 0 20px;
                }

                .shop-name__cell {
                    font-size: 30px;
                    color: #333;
                    text-decoration: none;
                }

                .order-number__cell {
                    text-transform: uppercase;
                    font-size: 14px;
                    color: #999;
                    text-align: right;
                }

                .order-number__text {
                    font-size: 16px;
                }

                .content__heading {
                    font-weight: normal;
                    font-size: 24px;
                    margin: 0 0 10px;
                }

                .content__desc {
                    color: #777;
                    line-height: 150%;
                    font-size: 16px;
                    margin: 0;
                }

                .section--margin {
                    margin: 30px auto;
                }

                .section--margin h4 {
                    font-weight: 500;
                    font-size: 16px;
                    color: #555;
                    margin: 0 0 5px;
                }

                .section--margin p {
                    color: #777;
                    line-height: 150%;
                    font-size: 16px;
                    margin: 0;
                }

                .link {
                    font-size: 16px;
                    text-decoration: none;
                    color: #1990C6;
                }

                .actions__cell {
                    display: flex;
                    justify-content: start;
                }

                .button.main-action-cell,
                .link.secondary-action-cell {
                    width: initial;
                    margin: 0;
                    text-align: left;
                }

                .button.main-action-cell {
                    margin-right: 15px;
                }

                .button__cell {
                    text-align: -webkit-center;
                    background-color: {{ dingdoong_accent_colour }};
                    border-radius: 4px;
                    min-width: 160px;
                }

                .button__text {
                    font-size: 16px;
                    text-decoration: none;
                    display: block;
                    color: #fff !important;
                    padding: 20px 15px;
                }

                .link__cell {
                    border-spacing: 0;
                    border-collapse: collapse;
                    margin-top: 19px;
                    font-size: 16px;
                }

                .content__cell {
                    padding-bottom: 40px;
                    border-width: 0;
                }

                .section__cell {
                    padding: 40px 0;
                }

                .section__cell h3 {
                    font-weight: normal;
                    font-size: 20px;
                    margin: 0 0 25px;
                }

                .order-list__item {
                    border-bottom: 1px solid #d7d7d7; 
                }

                .order-list__item__cell {
                    padding-bottom: 15px;
                }

                .order-list__item-title {
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 1.4;
                    color: #555;
                }

                .order-list__item-variant {
                    font-size: 14px;
                    color: #999;
                    font-weight: 400;
                }

                .order-list__item-discount-allocation {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    color: #777;
                    line-height: 150%;
                    font-size: 16px;
                }

                .row.subtotal-table {
                    margin-top: 20px;
                
                }

                .subtotal-spacer {
                    width: 40%;
                }

                .subtotal-line__text {
                    color: #777;
                    line-height: 1.2em;
                    font-size: 16px;
                    margin-top: 4px;
                }

                .subtotal-line__value {
                    text-align: right;
                    font-size: 16px;
                    color: #555;
                    font-weight: 550;
                }

                .subtotal-line__discount {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-top: 4px;
                    color: #777;
                    line-height: 1.2em;
                    font-size: 16px;
                }

                .subtotal-line__saved-value {
                    text-align: right;
                }

                .total-value {
                    margin-top: 20px;
                    border: 1px solid #d7d7d7;
                    border-right: none;
                    border-left: none;
                }

                .total-value .subtotal-line__text {
                    padding: 20px 0;
                }

                .total-value .subtotal-line__value {
                    font-size: 24px;
                    color: #555;
                }

                del {
                    color: #999;
                }

                .footer__cell {
                    padding: 35px 0;
                }

                .disclaimer__subtext {
                    color: #999;
                    line-height: 150%;
                    font-size: 14px;
                    margin: 0;
                }

                .text-accent-colour {
                    color: {{ dingdoong_accent_colour }} !important;
                }

                .datetime_title {
                    font-weight: bold;
                    margin: 0;
                }

                .order-list__item-price {
                    font-size: 14px;
                }
            </style>
        </head>

        <body>
            <table class="body">
                <tr>
                    <td>
                        <table class="header row">
                            <tr>
                                <td class="header__cell">
                                    <table class="container">
                                        <tr>
                                            <td>
                                                <table class="row">
                                                    <tr>
                                                        <td class="shop-name__cell">
                                                            {{ dingdoong_shop_name }}
                                                        </td>

                                                        <td>
                                                            <table class="order-po-number__container">
                                                                <tr>
                                                                    <td class="order-number__cell">
                                                                        <span class="order-number__text">
                                                                            Order {{ dingdoong_order_name }}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>

            <table class="row content">
                <tr>
                    <td class="content__cell">
                        <table class="container">
                            <tr>
                                <td>
                                    <h2 class="content__heading">${EMAIL_TITLE[emailType]}</h2>
                                    ${emailType === EmailTypeEnum.ReadyForPickup ? '<p class="content__desc">Bring your confirmation email when you come to collect your order</p>' : ''}

                                    <table class="section--margin">
                                        <tr>
                                            <td>
                                                <h4>${emailType === EmailTypeEnum.OutForDelivery ? 'Delivery' : 'Pickup'} location</h4>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>{{ dingdoong_location_name }}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>{{ dingdoong_location_address1 }}</p>
                                                <p class="content__desc">{{ dingdoong_location_address2 }}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>{{ dingdoong_location_city }} {{ dingdoong_location_province }} {{ dingdoong_location_zip }}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>{{ dingdoong_location_country }}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>{{ dingdoong_location_phone }}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <a class="link" href="http://www.google.com/maps/search/?api=1&query={{ dingdoong_location_name }} - {{ dingdoong_location_address1 }}, {{ dingdoong_location_address2_map }} , {{ dingdoong_location_city }}, {{ dingdoong_location_province }}, {{ dingdoong_location_zip }}"
                                                    target="_blank">
                                                    Open map&nbsp;
                                                    <span class="small">&rarr;</span>
                                                </a>
                                            </td>
                                        </tr>
                                    </table>

                                    {{ dingdoong_delivery_date_time }}

                                    <table class="row actions">
                                        <tr>
                                            <td class="actions__cell">
                                                <table class="button main-action-cell">
                                                    <tr>
                                                        <td class="button__cell">
                                                            <a href="{{ order_status_url }}" class="button__text">View your order</a>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table class="secondary-action-cell">
                                                    <tr>
                                                        <td class="link__cell">
                                                            or
                                                            <a class="link text-accent-colour" href="{{ dingdoong_shop_url }}" target="_blank">Visit our store</a>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>

            <table class="row section">
                <tr>
                    <td class="section__cell">
                        <table class="container">
                            <tr>
                                <td>
                                    <h3>Order summary</h3>
                                </td>
                            </tr>
                        </table>

                        <table class="container">
                            <tr>
                                <td>

                                    <table class="row subtotal-table subtotal-table--total">
                                        <tbody>
                                            <tr class="order-list__item">
                                                <td class="order-list__item__cell">
                                                    <table class="subtotal-table__container">
                                                        {{ dingdoong_order_summary }}
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table class="row subtotal-lines">
                                        <tbody>
                                            <tr>
                                                <td class="subtotal-spacer"></td>
                                                <td>
                                                    <table class="row subtotal-table">
                                                        <tbody>
                                                            <tr class="subtotal-line">
                                                                <td>
                                                                    <p class="subtotal-line__text">Subtotal</p>
                                                                </td>
                                                                <td class="subtotal-line__value">{{ dingdoong_order_subtotal }}</td>
                                                            </tr>
                                                            {{ dingdoong_order_discount }}
                                                            {{ dingdoong_order_shipping }}
                                                            {{ dingdoong_order_duties }}
                                                            {{ dingdoong_order_tax }}
                                                        </tbody>
                                                    </table>

                                                    <table class="total-value">
                                                        <tr class="subtotal-line">
                                                            <td class="subtotal-line__text">Total</td>
                                                            <td class="subtotal-line__value">{{ dingdoong_order_total }}</td>
                                                        </tr>
                                                        <tr class="subtotal-line">
                                                            <td></td>
                                                            <td class="subtotal-line__text subtotal-line__saved-value">You saved {{ dingdoong_order_saved }}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>

            <table class="row footer">
                <tr>
                    <td class="footer__cell">
                        <table class="container">
                            <tr>
                                <td>
                                    <p class="disclaimer__subtext">If you have any questions, reply to this email or contact
                                        us at <a class="link text-accent-colour" href="mailto:{{ dingdoong_shop_email }}">{{ dingdoong_shop_email }}</a></p>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </body>
    </html>
`;

export const replaceTemplateVariables = (template: string, variables: { [key: string]: string }): string => {
    for (const key in variables) {
      if (variables.hasOwnProperty(key)) {
        const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
        template = template.replace(regex, variables[key]);
      }
    }
  
    const parser = new DOMParser();
    const doc = parser.parseFromString(template, 'text/html');
  
    doc.querySelectorAll('a').forEach((a) => {
      const href = a.getAttribute('href');
      if (!href || href.trim() === '') {
        const style = a.getAttribute('style') || '';
        a.setAttribute('style', `${style}; pointer-events: none; cursor: default; text-decoration: none;`);
      }
    });
  
    return doc.documentElement.outerHTML;
  };
  